/* ==========================================================================
   Cart Bundle Tier (Feature 2) - volume discount ladder
   --------------------------------------------------------------------------
   Counts qualifying cart items (or their subtotal) and shows progress toward
   the merchant's native Shopify automatic volume discounts.

   It never touches line prices. Shopify applies the discount.

   Supawear build. Adds a self-check the 2EROS version did not have. Supawear
   runs sitewide automatic discounts that do NOT combine with the underwear
   tiers, so Shopify applies whichever is worth more, per line. During a big
   sitewide sale a static card would announce "Now 15% off" to a customer who
   is actually receiving 50%. So before claiming anything, the card compares
   the rate Shopify ACTUALLY applied against the rate it is about to claim,
   and stands down when it is not the binding offer. This also covers bundle
   lines, discount codes and anything else added in future, with no config.
   ========================================================================== */
(function () {
  'use strict';

  var C = window.CartRewardsCore;
  if (!C) {
    if (window.console) console.warn('[cart-rewards] core runtime missing - Bundle Tier disabled');
    return;
  }

  var CACHE_TTL = 60 * 60 * 1000; // 1 hour
  var OUTBID_TOLERANCE = 0.005;   // half a point, to absorb rounding

  function splitList(str) {
    return String(str || '')
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);
  }

  /* case-insensitive match with optional trailing wildcard: "Underwear*" */
  function matchesAny(value, list) {
    if (!value || !list.length) return false;
    var v = String(value).toLowerCase();
    for (var i = 0; i < list.length; i++) {
      var pattern = list[i];
      if (pattern.charAt(pattern.length - 1) === '*') {
        if (v.indexOf(pattern.slice(0, -1)) === 0) return true;
      } else if (v === pattern) {
        return true;
      }
    }
    return false;
  }

  /* "15% off" -> 0.15. Returns null when the label carries no percentage, in
     which case the outbid check is skipped rather than guessed at. */
  function parsePct(label) {
    if (!label) return null;
    var m = String(label).match(/(\d+(?:\.\d+)?)\s*%/);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return isNaN(n) ? null : n / 100;
  }

  function cacheGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || Date.now() - obj.t > CACHE_TTL) return null;
      return obj.v;
    } catch (e) {
      return null;
    }
  }
  function cacheSet(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v: value }));
    } catch (e) {}
  }

  function BundleTier(host) {
    this.host = host;
    this.cfg = JSON.parse(host.querySelector('[data-abt-config]').textContent);
    this.template = host.querySelector('[data-abt-template]');

    this.tiers = (this.cfg.tiers || [])
      .filter(function (t) { return C.num(t.threshold) !== null && C.num(t.threshold) > 0; })
      .sort(function (a, b) { return a.threshold - b.threshold; });

    if (this.tiers.length !== (this.cfg.tiers || []).length) {
      C.warn('one or more tier blocks are missing a threshold and were skipped');
    }

    this.tagList = splitList(this.cfg.qualifying.tags);
    this.typeList = splitList(this.cfg.qualifying.productTypes);
    this.excludeTagList = splitList(this.cfg.qualifying.excludeTags);
    this.excludeTypeList = splitList(this.cfg.qualifying.excludeTypes);
    this.collectionIds = {};
    (this.cfg.qualifying.collectionProductIds || []).forEach(function (id) {
      this.collectionIds[String(id)] = true;
    }, this);
    this.collectionIdsResolved = (this.cfg.qualifying.collectionProductIds || []).length > 0;
    this.needsFeed =
      !!this.cfg.qualifying.collectionHandle &&
      !this.collectionIdsResolved &&
      C.num(this.cfg.qualifying.collectionCount) > 50;

    this.tagCache = {};
    this.pendingHandles = {};
    this.lastTierIndex = -1;
    this.viewedFired = false;
  }

  BundleTier.prototype.init = function () {
    var self = this;

    if (!this.tiers.length) {
      C.warn('Bundle Tier has no valid tiers - nothing to render');
      return;
    }

    this.mounts = C.createMounts({
      key: 'abt',
      order: 20,
      template: this.template,
      config: this.cfg,
      onMount: function (root) {
        if (self.lastState) self.paint(root, self.lastState);
      }
    });

    if (this.needsFeed) this.loadCollectionFeed();

    this.unsubscribe = C.bus.subscribe(function (cart) { self.render(cart); });

    if (this.cfg.designMode) {
      document.addEventListener('shopify:section:load', function () { self.mounts.sync(); });
    }

    C.log('Bundle Tier ready', this.cfg.programName, this.tiers);
  };

  BundleTier.prototype.destroy = function () {
    try { if (this.unsubscribe) this.unsubscribe(); } catch (e) {}
    this.unsubscribe = null;
    try { if (this.mounts) this.mounts.destroy(); } catch (e) {}
  };

  /* --------------------------------------------------- qualifying matching */

  BundleTier.prototype.loadCollectionFeed = function () {
    var self = this;
    var handle = this.cfg.qualifying.collectionHandle;
    var key = 'abt:coll:' + handle;
    var cached = cacheGet(key);
    if (cached) {
      cached.forEach(function (id) { self.collectionIds[String(id)] = true; });
      this.collectionIdsResolved = true;
      C.log('collection ids from cache', cached.length);
      return;
    }

    var ids = [];
    var page = 1;

    function next() {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          products.forEach(function (p) { ids.push(p.id); });
          if (products.length === 250 && page < 4) {
            page++;
            return next();
          }
          return ids;
        });
    }

    next()
      .then(function (all) {
        all.forEach(function (id) { self.collectionIds[String(id)] = true; });
        self.collectionIdsResolved = true;
        cacheSet(key, all);
        C.log('resolved ' + all.length + ' qualifying product ids from collection feed');
        self.rerender();
      })
      .catch(function (e) {
        C.warn('could not read collection feed for "' + handle + '" - falling back to counting all cart items', e);
        self.collectionIdsResolved = false;
        self.needsFeed = false;
        self.rerender();
      });
  };

  BundleTier.prototype.loadTags = function (handles) {
    var self = this;
    var todo = handles.filter(function (h) { return h && self.tagCache[h] === undefined; });
    if (!todo.length) return;

    Promise.all(
      todo.map(function (handle) {
        var key = 'abt:tags:' + handle;
        var cached = cacheGet(key);
        if (cached) {
          self.tagCache[handle] = cached;
          return Promise.resolve();
        }
        return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (p) {
            var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
            self.tagCache[handle] = tags;
            cacheSet(key, tags);
          })
          .catch(function () {
            self.tagCache[handle] = [];
          });
      })
    ).then(function () {
      self.rerender();
    });
  };

  BundleTier.prototype.hasFilters = function () {
    return this.tagList.length > 0 || this.typeList.length > 0 || Object.keys(this.collectionIds).length > 0;
  };

  BundleTier.prototype.qualifies = function (item) {
    /* Exclusions are checked first and always win. */
    if (matchesAny(item.product_type, this.excludeTypeList)) return false;

    if (this.excludeTagList.length) {
      var itemTags = this.tagCache[item.handle];
      if (itemTags === undefined) {
        /* tags are not in the cart payload - fetch them, count nothing yet */
        this.pendingHandles[item.handle] = true;
        return false;
      }
      for (var x = 0; x < itemTags.length; x++) {
        if (matchesAny(itemTags[x], this.excludeTagList)) return false;
      }
    }

    if (!this.hasFilters()) return true;

    if (matchesAny(item.product_type, this.typeList)) return true;

    if (Object.keys(this.collectionIds).length && this.collectionIds[String(item.product_id)]) {
      return true;
    }

    if (this.tagList.length) {
      var tags = this.tagCache[item.handle];
      if (tags === undefined) {
        this.pendingHandles[item.handle] = true;
        return false;
      }
      for (var i = 0; i < tags.length; i++) {
        if (matchesAny(tags[i], this.tagList)) return true;
      }
    }

    return false;
  };

  /* --------------------------------------------------------------- render */

  BundleTier.prototype.rerender = function () {
    if (C.bus.cart) this.render(C.bus.cart);
  };

  BundleTier.prototype.renderDemo = function () {
    this.renderValues(
      this.cfg.demo.qualifyingCount || 0,
      C.money.toActiveMinor(this.cfg.demo.qualifyingSubtotal || 0) || 0,
      0,
      0
    );
  };

  BundleTier.prototype.render = function (cart) {
    if (!cart) return;

    /* Theme editor with an empty cart: show the preview numbers instead.
       With a real cart, follow the real cart - the editor is not a special
       case for reading, only for writing. */
    if (this.cfg.designMode && !(cart.item_count > 0)) {
      this.renderDemo();
      return;
    }

    this.pendingHandles = {};

    var basis = this.cfg.subtotalBasis === 'before' ? 'original_line_price' : 'final_line_price';
    var count = 0;
    var subtotal = 0;
    var discount = 0;
    var original = 0;
    var self = this;

    (cart.items || []).forEach(function (item) {
      if (self.cfg.qualifying.excludeGifts && C.isGiftLine(item)) return;
      if (!self.qualifies(item)) return;
      count += C.num(item.quantity) || 0;
      var v = item[basis];
      if (v == null) v = item.final_line_price;
      subtotal += C.num(v) || 0;
      discount += C.num(item.total_discount) || 0;
      original += C.num(item.original_line_price) || 0;
    });

    var pending = Object.keys(this.pendingHandles);
    this.awaitingTags = pending.length > 0;
    if (pending.length) this.loadTags(pending);

    this.renderValues(count, subtotal, discount, original);
  };

  BundleTier.prototype.renderValues = function (count, subtotal, discount, original) {
    var self = this;
    var mode = this.cfg.measurementMode === 'subtotal' ? 'subtotal' : 'count';
    var currency = C.money.info().active;

    /* In subtotal mode thresholds are entered in shop base currency. */
    var tiers = this.tiers.map(function (t) {
      return {
        id: t.id,
        raw: t.threshold,
        value: mode === 'subtotal' ? C.money.toActiveMinor(t.threshold) : t.threshold,
        label: t.label,
        subLabel: t.subLabel,
        discount: t.discount
      };
    });

    var value = mode === 'subtotal' ? subtotal : count;
    var max = tiers[tiers.length - 1].value;

    var currentIndex = -1;
    for (var i = 0; i < tiers.length; i++) {
      if (value >= tiers[i].value) currentIndex = i;
    }
    var next = tiers[currentIndex + 1] || null;
    var current = currentIndex >= 0 ? tiers[currentIndex] : null;

    /* ---- is this tier actually the binding offer? -------------------
       Compare what Shopify applied against what we are about to claim.
       Claiming the current tier when reached, otherwise the next one we are
       promising. If the real rate already beats it, something else is
       driving the price and the card must not put a number on it. */
    var actualRate = C.appliedRate(discount, original);
    var claimed = parsePct(current ? current.discount : next ? next.discount : null);
    var outbid = false;
    if (this.cfg.verifyClaim !== false && actualRate !== null && claimed !== null) {
      outbid = actualRate > claimed + OUTBID_TOLERANCE;
      if (outbid) {
        C.log(
          'tier claim suppressed: Shopify applied ' +
            (actualRate * 100).toFixed(1) +
            '% but this tier claims ' +
            (claimed * 100).toFixed(1) +
            '%'
        );
      }
    }

    var locale = this.cfg.language || null;
    var needValue = next ? Math.max(0, next.value - value) : 0;
    var needMoney = C.money.format(needValue, currency, locale);
    var needShort = mode === 'subtotal' ? needMoney : String(needValue);
    var needLong =
      mode === 'subtotal' ? needMoney : String(needValue) + ' ' + (needValue === 1 ? 'item' : 'items');

    var tags = {
      items_needed: '<b>' + C.esc(needShort) + '</b>',
      items_needed_label: '<b>' + C.esc(needLong) + '</b>',
      amount_needed: '<b>' + C.esc(needMoney) + '</b>',
      next_tier_discount: next ? next.discount : '',
      current_tier_discount: current ? current.discount : '',
      applied_discount: actualRate !== null ? Math.round(actualRate * 100) + '%' : '',
      next_threshold: next
        ? mode === 'subtotal'
          ? C.money.format(next.value, currency, locale)
          : String(next.raw)
        : ''
    };

    var state = !next ? 'max' : currentIndex >= 0 ? 'between' : value <= 0 ? 'empty' : 'below';

    var template;
    if (outbid) {
      template = this.cfg.copy.outbid || 'A better offer is already applied to these items';
    } else {
      template =
        state === 'max'
          ? this.cfg.copy.atMax
          : state === 'empty'
          ? this.cfg.copy.empty || this.cfg.copy.belowTier1
          : currentIndex >= 0
          ? this.cfg.copy.betweenTiers
          : this.cfg.copy.belowTier1;
    }

    var message = C.mergeTags(template, tags);

    /* Tags arrive asynchronously. Don't flash an empty card in between. */
    if (state === 'empty' && this.awaitingTags && this.lastState) return;

    var view = {
      state: state,
      outbid: outbid,
      messageHTML: message,
      messageText: message.replace(/<[^>]+>/g, ''),
      percent: max ? C.clamp((value / max) * 100, 0, 100) : 0,
      dense: tiers.length > 3,
      currentLabel: current ? (this.cfg.copy.currentPrefix || '') + ' ' + current.discount : '',
      showCurrent: !!current && !outbid,
      markers: tiers.map(function (t) {
        return {
          index: tiers.indexOf(t),
          percent: max ? C.clamp((t.value / max) * 100, 0, 100) : 0,
          reached: value >= t.value,
          label: t.label,
          tip:
            t.discount +
            ' at ' +
            (mode === 'subtotal'
              ? C.money.format(t.value, currency, locale)
              : t.raw + (t.raw === 1 ? ' item' : ' items'))
        };
      })
    };

    this.lastState = view;
    if (this.mounts) {
      this.mounts.sync();
      this.mounts.roots().forEach(function (root) { self.paint(root, view); });
    }

    if (!this.cfg.designMode && this.cfg.analytics) {
      this.fireEvents(currentIndex, current, count, subtotal, currency, outbid);
    }
  };

  BundleTier.prototype.paint = function (root, view) {
    root.setAttribute('data-abt-state', view.state);
    root.setAttribute('data-abt-dense', view.dense ? 'true' : 'false');
    root.setAttribute('data-abt-outbid', view.outbid ? 'true' : 'false');

    var fill = root.querySelector('[data-abt-fill]');
    if (fill) fill.style.width = view.percent.toFixed(2) + '%';

    var bar = root.querySelector('[data-abt-bar]');
    if (bar) {
      bar.setAttribute('aria-valuenow', String(Math.round(view.percent)));
      bar.setAttribute('aria-valuetext', view.messageText);
    }

    var msg = root.querySelector('[data-abt-message]');
    if (msg) msg.innerHTML = view.messageHTML;

    var chip = root.querySelector('[data-abt-current]');
    if (chip) {
      chip.hidden = !view.showCurrent;
      chip.textContent = view.currentLabel.trim();
    }

    var markers = root.querySelectorAll('[data-abt-marker]');
    [].forEach.call(markers, function (el, i) {
      var m = view.markers[i];
      if (!m) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      el.style.left = m.percent.toFixed(2) + '%';

      var isNext = !m.reached && view.markers.filter(function (x) { return !x.reached && x.percent < m.percent; }).length === 0;
      el.setAttribute('data-abt-status', m.reached ? 'reached' : isNext ? 'current' : 'upcoming');

      var tip = el.querySelector('[data-abt-marker-tip]');
      if (tip) tip.textContent = m.tip;
      var sr = el.querySelector('[data-abt-marker-sr]');
      if (sr) sr.textContent = m.tip + (m.reached ? ' - unlocked' : ' - not yet reached');
    });

    C.liveAnnounce(root.querySelector('[data-abt-live]'), view.messageText);
  };

  BundleTier.prototype.fireEvents = function (currentIndex, current, count, subtotal, currency, outbid) {
    var base = {
      program: this.cfg.programName,
      items: count,
      cart_value: subtotal / 100,
      currency: currency,
      outbid: !!outbid
    };

    if (!this.viewedFired) {
      this.viewedFired = true;
      C.track('bundle_tier_viewed', base);
    }

    if (currentIndex > this.lastTierIndex && current) {
      C.track('bundle_tier_reached', Object.assign({ tier: current.label, tier_discount: current.discount }, base));
    } else if (currentIndex < this.lastTierIndex && this.lastTierIndex >= 0) {
      var lost = this.tiers[this.lastTierIndex];
      C.track('bundle_tier_lost', Object.assign({ tier: lost ? lost.label : '', tier_discount: lost ? lost.discount : '' }, base));
    }
    this.lastTierIndex = currentIndex;
  };

  /* ----------------------------------------------------------- bootstrap */

  function boot() {
    var hosts = [].slice.call(document.querySelectorAll('[data-abt-host]'));
    if (!hosts.length) return;
    if (window.__abtInstance && window.__abtInstance.host.isConnected) return;

    for (var i = 0; i < hosts.length; i++) {
      try {
        var instance = new BundleTier(hosts[i]);
        instance.init();
        window.__abtInstance = instance;
        return;
      } catch (e) {
        C.warn('Bundle Tier failed to start - removing itself', e);
        try {
          var stale = document.querySelectorAll('.abt-mount');
          for (var j = 0; j < stale.length; j++) stale[j].remove();
        } catch (e2) {}
      }
    }
  }

  C.onReady(boot);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-abt-host]')) {
      if (window.__abtInstance) {
        try { window.__abtInstance.destroy(); } catch (err) {}
        window.__abtInstance = null;
      }
      boot();
    }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-abt-host]') && window.__abtInstance) {
      try { window.__abtInstance.destroy(); } catch (err) {}
      window.__abtInstance = null;
    }
  });
})();
